interface VideoSourceSelectOption {
  value: string;
  label: string;
}

interface VideoSourceSelectProps {
  value: string;
  onChange: (value: string) => void;
  options: VideoSourceSelectOption[];
  className: string;
  ariaLabel: string;
}

/**
 * The source picker shared by the expanded header and the compact overlay
 * layouts of SynchronizedVideoPlayer.
 */
export function VideoSourceSelect({
  value,
  onChange,
  options,
  className,
  ariaLabel,
}: VideoSourceSelectProps) {
  return (
    <select
      aria-label={ariaLabel}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={className}
    >
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
